import { global } from '../../theme'


export default {
  ...global,
}
